module.exports = __webpack_public_path__ + "static/media/game.87f537fd.mp4";